import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/maximo-app-framework/maximo-autoscript-documentation/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The scripting application now has a `}<strong parentName="p">{`Test`}</strong>{` button to help test the script that you authored.
You can use `}<strong parentName="p">{`Test`}</strong>{` to prepare the test data and execute the script right from the test dialog.
All the logs would be printed out in the `}<strong parentName="p">{`Process Log`}</strong>{` text area without enabling any logging as long as the `}<inlineCode parentName="p">{`service`}</inlineCode>{` variable was used for the log.
In cases where the script needs an MBO for the test, the dialog provides a way (`}<inlineCode parentName="p">{`Object Path`}</inlineCode>{`) to select the MBO for testing the script. The following sample
way shows how to set the object path. `}</p>
    <pre><code parentName="pre" {...{}}>{`ASSET[assetnum='SPFN0001']
`}</code></pre>
    <p>{`Note that if you had set the path value to just `}<inlineCode parentName="p">{`ASSET`}</inlineCode>{`, it would have created a new MBO for the Asset and used that for this script.`}</p>
    <p>{`This selects an asset with assetnum SPFN0001 and uses the MBO for the `}<inlineCode parentName="p">{`mbo`}</inlineCode>{` variable in the script context.
This can be leveraged for testing Object or Attribute or Action or Condition Launch point scripts.
The dialog allows you to set attribute or value pairs to prepare the MBO for the test using the \`Set Attribute Value’ table.
The process makes a best attempt to not commit the modified MBO, but in certain cases this is unavoidable. For example, in cases where the event is after a commit, the MBO is already committed.
For other cases, the script code itself might initiate a commit. The following screen shot showcases some of the test functionalities. `}</p>
    <p>{`For tesing object init event:`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACQElEQVQoz32R208TURCH+2/7pEZjEB+AB42iD4gxKsQQowHaUtttS8t2e4FS7WVLt91NqchF2m53t93LZ/ZADEriJJOZMye/78yZiVwORxwPftIz+gxOTjnq6jRabVrtDo12D/34hJZmUG9rHHUM1JaOqum0NYP+4ITT819cXI45PTvn4kefyNziU+7NLwm/82CejS9RdKOP1jPo9nQ6Wg+tpwvv6jpdwxD58WDA6vuP3J1b4NHCM+7PL/HwySKRre0o29E4yZRENBan0WgSmu95/M8CIJfLE+rjOzvEdxJCH0lLEulUBllWkOU9NE3DdV0cZ4rn+3ieRxAEIob12WyG7wfMXJf9SoVyuSzi/n6FYrFIJJvNikQpKuTzebrdrgBMp1Nmro9l2VcdBYGA2bb9B1wqlZFlGUVRBCOXyxHZ3d2lVCqJQnipqirD4YjxeMxkMmFsmoxGIyYTk/HYxPV88UAIDbsrFApCGzLS6fRtYLut4s4c0YllWQyHQ0zTxHFsLNvGuwEMdTeBmUzmX+AeTbXD0PYJgqtv+r5/vYK/LaxXKpXbwEwmKw6KUqRSUkjkD1mTNMyJJeZoO2G3jojOtfveDC9cysGBmHsIDfWSJBG5OijCw6G2VRUCF9uysC1bxIk5YerYAhaOoqWfMTId1FZTbLd2WOX7txqFgkwkupOgVjukWq1Sr9dptlpsJVLEkl9JSEmiUpqNRJZPsQSbm1HSqSSPl9d5sRbjzfpnVlbfsrzyjlevP/D85Sq/AQHgDpWApIXkAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Object Init Event",
        "title": "Object Init Event",
        "src": "/maximo-autoscript-documentation/static/8900dad7559f8b6f2ca715e286970785/655e2/initevent.png",
        "srcSet": ["/maximo-autoscript-documentation/static/8900dad7559f8b6f2ca715e286970785/7fc1e/initevent.png 288w", "/maximo-autoscript-documentation/static/8900dad7559f8b6f2ca715e286970785/a5df1/initevent.png 576w", "/maximo-autoscript-documentation/static/8900dad7559f8b6f2ca715e286970785/655e2/initevent.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Note that the resulting MBO is serialized and presented in the `}<strong parentName="p">{`Data`}</strong>{` field of the dialog. This helps you to validate when the the script execution resulted in the right state of the MBO.`}</p>
    <h2>{`For testing “On Add” object events:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACZElEQVQoz1WSa08TURCG92+bmIjRGIRE4IPGhAQJmogmRKOFdnuBXqC2223BglDWXreUUuh1t9B2l+1jzoGgTjLnfXc+PGdm9ii9vkWj1aHeaNG8uKRUNSkYJYximUKxhtloYVRMTopVirUzSuU6xdI5RqlKo9mi3enR7dtctTt0Lxoos4uvmXm5yMzcEo+ezfPFF6BWP6NSq1OtmZSrJpWqKX3VrMus1EzOm03W1jd4MrvAi4U3PJ1b4vn8IkpADaIGQ2xvRxG+UDhFxO3t7X8qwvP+ehFaJoM/ECAUjsgUHCURj7O3u8tuYpdYNEalUmYymXBzc4PjOIxGY1zHwXVdxpOJVM/zpObzeXLZLAcH+zJ1XUdR/SqbPh/+QITA5g75n0cMrAGDgcXAsuj2evT6fel7AwvXvetSALPZLGlNI5PJSFgymUQJBlT8fj+qus2Wb5tM9pDz/pCr4Yj29ZjaZYeWdc3lcERzMML1vIdV5HI5NE2TMAGPx+Mo4hA3aFqGrK4R2suzHqsyGk+4dV05vhjdcYR3JEiMPHEcCfkXmEgkUMQhPkQxnU5jGL+x7SGWZWHbNpZty1GHQ1vWZIpaf4Cu3wFFQw/AWCwmYaKYSqUol8tyPxPZlfOgYoemadLpdLgZWnQ7bTK6TiqVvofqCJbyI5mUs4u/HYlEMAzj7k1MpzC9V2GmHlOxv6lHrWVzPfYoGgUO9nMcHeY5/nWEpqVR1HCEo8ND+QROjo85PTUIRKJshsKEdsIEd6J8C0fZCMX56g+y5Vd5/Oo9K599vPv0nZUPn1le/cjy6jpvl9f4Ayg/CXbmbB61AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Object on add Event",
        "title": "Object on add Event",
        "src": "/maximo-autoscript-documentation/static/1b560ffed6257d2615b81afc1b80ae51/655e2/onaddevent.png",
        "srcSet": ["/maximo-autoscript-documentation/static/1b560ffed6257d2615b81afc1b80ae51/7fc1e/onaddevent.png 288w", "/maximo-autoscript-documentation/static/1b560ffed6257d2615b81afc1b80ae51/a5df1/onaddevent.png 576w", "/maximo-autoscript-documentation/static/1b560ffed6257d2615b81afc1b80ae51/655e2/onaddevent.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`As apparent you set values:
ASSETNUM	TESTADD10
ASSETTYPE	FLEET`}</p>
    <p>{`This results in an error because ASSETNUM and ASSETTYPE mismatch - as shown in the screen shot.`}</p>
    <p>{`The following screenshot is when there is no error thrown:`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACYElEQVQoz1WS62/SYBSH+2/rF2c0Rt0Htw8akyVqFhM3o9FkbLTcHLAhlIKTzY1VWLmMVW6jLUihjD3mfZm3k/zec3qSPj2/nlcZOB6tdp9mq439o0O11qBsVjErZ5QrdRqtNqbV4KRSo1I/p3rWpFK9wKzWaNltev0Bl86Qbq/P5Y8WysOVpyw9WmHp8Sq37i3zIaRSb55j1ZvU6g3Oag2sWkPWtUZTyqo3uLBt1jfec+fhEx48ecbdx6vcX15BUbUIWiRKIrGLqMvlU0RcXV39l0XM539rEXo+T1hVicbiUoKjpFMp9vf22EvvkdxNYllnTKdTxuMxQRDg+xNmQcBsNmMynco8n89lLpVKFAsFDg6+SBmGgaKFNbZDIcJqHHX7E6WvR7iei+t6uJ7H5WDAwHFkPXA9ZrPFlAJYKBTI6Tr5fF7CMpkMSkTVCIfDaFqCnVCCfOEQ2xvTHfn0fk6od/q0vZ90Rj626zObz//8imKxiK7rEibgqVQKRRziC7qep2DoRPdLbCRrTKaBfEnYF9aFfveEZdEXkH+B6XQaRRziQTRzuRym+R1vOMJxHClp1fEYjYYMh0M8z8PzhjiOi2EsgGKgP8BkMilhopnNZrEsi16vi23bdDodXNeVC/J9X041DQKxbyb+mLxhkM3mbqAGgqV8zmSkd7HteDyOaZqLO3F9fZPnC/0T590RfgAVs8zBlyJHhyWOvx2h6zkULRbn6PBQXoGT42NOT03UxC47sRiRRIxoKs3HWJJ3WoJQOMLWtsrt1U1ebG7xcnOLF6/fsvbqDWuvNni+ts4vGJgJghIrAekAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Object on add Event",
        "title": "Object on add Event",
        "src": "/maximo-autoscript-documentation/static/3764ca54a5bd30aa46c894b2c4ec127a/655e2/onaddevent2.png",
        "srcSet": ["/maximo-autoscript-documentation/static/3764ca54a5bd30aa46c894b2c4ec127a/7fc1e/onaddevent2.png 288w", "/maximo-autoscript-documentation/static/3764ca54a5bd30aa46c894b2c4ec127a/a5df1/onaddevent2.png 576w", "/maximo-autoscript-documentation/static/3764ca54a5bd30aa46c894b2c4ec127a/655e2/onaddevent2.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`The following example is from app validate event:`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACW0lEQVQoz2WR2U8TURSH5+/2RY3GEHwAXoyRFyFGSVRiVOgUaKEr3UsXKLS0M23ZWqCdzrTTztL5zFyCRj3J7557TnK/exbpfjBEvejTverTvblH7VxycnZO/bzFudKl2b3mpK5Sq7VpKG3UpkJL6dBQu1xc39K7GzLQDPq3dwxuLpEWlt/wfHGFZ4srPHmxyOYPGbXdodlSaSpt4f24paooahu1c4HS7nB1dc36xheeLizxaumB8fL1MpIsBwnu7BIOHxAI7nB6doZvlmXhzD1msxmP5roueB6e54k4k8kSkGV290JCPkeKRaIk4nHisQSRSARVUQTMtm3x0Nd8Pmc+/3P3vQ8vlUoU8nmOjopCuVwOSQ7IbG1tIQf3kbf3KZcqaJqGruuMdJ3BYIimDTF0naE2wnZcUZ3jOOTzedLpDNlsVsCSySRSNBollUoLJRJJjmun3E9MbsdToXb/jp4+pm9MudJMHHf+G1goFMhkMgLmw32WlEgkROAni/ks+6kqm8ku5szCdl2mloVlO0JT2xGtP87zX2AsFnsA+olsLkcmk6ZyfErnZohhGIzHYyFtZDCZjDEnExHrhsHENCmVyqTT6b+B/vFYYSqVQlUV8Fyx3ZllCW/ZNqZpctPridk69gxDHwng4eGhqDKbzYmlSulUSoD8n+LxOM1mk//Nw3NdxrrGbDal0b3HmFg0G3WKxQLVSpmT46roUAruhahWK5TLZWq1E87qdQKhA+RwiL1ImMBBlM29GN93QnyVI+yE9ll49403H7dZ+/yTtQ+fWH3va4O3q+v8At+lCxSpqX69AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "app validate event",
        "title": "app validate event",
        "src": "/maximo-autoscript-documentation/static/7620d058b011e6597a01f1eb9d908c0a/655e2/appvalidate.png",
        "srcSet": ["/maximo-autoscript-documentation/static/7620d058b011e6597a01f1eb9d908c0a/7fc1e/appvalidate.png 288w", "/maximo-autoscript-documentation/static/7620d058b011e6597a01f1eb9d908c0a/a5df1/appvalidate.png 576w", "/maximo-autoscript-documentation/static/7620d058b011e6597a01f1eb9d908c0a/655e2/appvalidate.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Object path: ASSET
Set values:
ASSETNUM	TESTVAL1
ASSETTYPE	FLEET
Result: Error is thrown because ASSETNUM and ASSETTYPE mismatch`}</p>
    <h2>{`Can Add Event`}</h2>
    <p>{`The following screen shot shows the `}<inlineCode parentName="p">{`Can Add Event`}</inlineCode>{` in which you select a PO which does not have a vendor and attempt to add a POLINE, using the object path notation to invoke the script.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACN0lEQVQoz22R2U8aURSH5+/uS9vENEYf1IcuqQ+tTROaxvjQNgVEUFaZYVWoyDIMsrgEFWcQmEX4mnspbW16k9/cOffmfPf8zlEGA5Pu+SW9iyva3XNanR6nNZ1qvUmt3uS0btAwOvK+phvUjA56u0e93qV7eUP/esDt3ZD+9Q23lz2U5fWXPF/Z4NnKBk+WVtn5FqDd7WGcdWj9ktFqoxstjLM2rfY8Pr+44MOnbZ4ur/Fi7ZVkLK2uo/gDQfzBXSKRfQKBEJXKKbPZjIlt8/DwICWWOHNdF8dxmE6n8kzVMvgDAUJ7YangbgglEY+TSCRIJQ+JRZPoDR3P86Sm09lfwDlUwMQu7o+OiuTzOYrFglQ2m0URsFwuJwNVValWqwwGdwyHQ0ajkdxNy+L+XuxDXG/+gACKPJGTyWRkfiqVQkkmkzIQSqdVdL2B506wbfs3cDKZx0ILuwugpmkyV/zHYrE5cFGhpqY5qepcma60CDNp739LgAuFwiNgPB7/A8xksuSzGgdqia/pDuOJjee5OK7LxHbkQERVi8GI3h6XStLyI6D4LCoUlpvCsjPGNE0sy8I0LQamJeN+/1r2dzyyZCuKxSMOD9OySlFQNBpFUdW0fEVIDEjX9X/MzRYeGd9beK5DoztgOHJoNmoUCnnKpWNOfpTRNBXFvxuS4xf9KJfLnFQq+MP7BCNh9g4i+Pej7OzF+BIMsx2IEgxFWN3c4Y3vO1ufv7L10cfmex+b73y8frvFT01EDaRsiHBpAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Can Add Event",
        "title": "Can Add Event",
        "src": "/maximo-autoscript-documentation/static/6ad2d203a616abe554ce496ff3c7e3ae/655e2/canadd.png",
        "srcSet": ["/maximo-autoscript-documentation/static/6ad2d203a616abe554ce496ff3c7e3ae/7fc1e/canadd.png 288w", "/maximo-autoscript-documentation/static/6ad2d203a616abe554ce496ff3c7e3ae/a5df1/canadd.png 576w", "/maximo-autoscript-documentation/static/6ad2d203a616abe554ce496ff3c7e3ae/655e2/canadd.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Object path: PO`}{`[ponum=‘1056’]`}{`/POLINE
Result: Error is thrown because PO do not have vendor`}</p>
    <h2>{`Can Delete`}</h2>
    <p>{`The following screenshot shows the `}<inlineCode parentName="p">{`Can Delete Event`}</inlineCode>{` test:`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACRElEQVQoz4XS20/TYBzG8f7d3qjRKMEL8IZouBFilEQlMRJ27MZOsHUHxhibrG5tdwCEMbZ25279mrdjSLyxydP3qp/3fX59pdvOHXrzmsbFNY2rW/R6i9JPlYpaQ9UaVBtXlCoGpbJBpWagVzVqWh1Vb9C8vOF3+45O1+L6pk3nqoW0sr7B89W3PFt9y5MXq+zueak3WmhGg5pu8KuqoRt1NMNANxpo9SaaXufi4pLtna88XVnj1drCePlmHcnr9eHzBwiFw3h8fs4rFcTjOA7/e5R0mn2Pl0BQdiMcKRqJEI/HiUcTRCIRVFXFsvoMBgPG4zGj0YjhcHi/jrBnMxezbZt8Pk8ulyWfP3aTyWSQAoEAsiwTDscJhSIUi2f0+303lmXR6XTo9XoMBn1Mq49tL8DJZIKiKG7S6bSLHR4eIiUSCbLZLNlshmQyiWEYD5Vns5mb+Xz+qKjzAApoCQojGo0iibpCT6cz5DIK4VSR78kWU/ckDnNnEbGBgJe4GIeA0o/AWCz294QCVVIpzsrnXLZ7mKbpVjZNi7uu6Y5AzHU5iv5gSD5/QiqVcr99AMVrCYrKuq7jOHO30nQ6Xay2zWA4pNlq0e32mE5GmGaPk0KBo6Oj+9oZ96dKqWTShcROon61Wv3ncjhuZrZN3+wyHg1R622swYSqWuH4OEfxtEDprIiipJB8QZli8ZRCoUC5XHLvoUc+wBuSCUZCeA6i7AZj/PDLfPNG8csHvH6/y8anfba+7LH18TObH0R2eLe5zR/MXgyobW+6GAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Can Delete Event",
        "title": "Can Delete Event",
        "src": "/maximo-autoscript-documentation/static/3e8506a483a489dc0e42ebadb4f49570/655e2/candelete.png",
        "srcSet": ["/maximo-autoscript-documentation/static/3e8506a483a489dc0e42ebadb4f49570/7fc1e/candelete.png 288w", "/maximo-autoscript-documentation/static/3e8506a483a489dc0e42ebadb4f49570/a5df1/candelete.png 576w", "/maximo-autoscript-documentation/static/3e8506a483a489dc0e42ebadb4f49570/655e2/candelete.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Object path format: ASSET`}{`[assetnum=‘7500’]`}{`
Result: Error is thrown of ASSETTYPE is FLEET`}</p>
    <p>{`Adding setup logic for virtual (aka Nonpersistent) MBOs on setup:`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACWElEQVQoz12S60/aUBiH+bv3ZVtiNuOW6L7oEr/MZdnMzPwwMRRvCIhgCxQRxUspBQGvIJdSLm15lnMY+7CTPDn5neZ9zvu2DTRbL9TvHqg1Hrit3WFV6xSvDIySxbVR5tKoUK3fU6nWMKwaRrVByWhgWHUa9488NV9otXs8PTdp3dcJzC8t82bhk+TV3Ec2gwrlShXDtChZVUyrglmuTLNZltyUTG5rNb6u/+L1/CLvFpd5u/CJuQ9LBJRwmPDOHpHDKCElTLF4yWTi4zgDRq6H646ZLc91ccdjxqORzKqmEQop7O7tS8I7uwRisSixWIxUSiORSGKWTFxR6Lr4nofnCel093yfyWQiZeK5rutks1lyuk4up5NOpwkoisLWVhBFibC9rZDL5Xl6fqbT6dDtdmm325Jup8NLu8N47ErhcDhEVVWJpmlSdnx8TCCRSMhbMpk0yVSKilWejud5jEYjiejQ933JrENxLkQzMpmMnFQKhV3T0mQ0laR+ydFFC8+fFs4E/y8xsqibdSiE8Xh8KhRBCNOaiqqfk71+pN93cBwH2+7T7dn0+32JyL2eLT/aaT7PycmJFP8TxuNHMojDVCpFtWIx6HdoNBo0m01sIXIG2LZNs9WSl7jjIaPRkNxpnmQy+bfLNNFolMCsZYF4qaZpMhwMsHs9uU88bzrjxMcbT3+X2rOD60Pp5gpdz1I4y3NxXkBVTwiE9/YpFM7I5/MUi0Wurq4JR6LsHEY4iEUIHcbY3IvxO7zPRugQZfeA959/svI9yNpGkLVvP1j9IlhnZXWNP/lsDEEFf0v0AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Setup Event",
        "title": "Setup Event",
        "src": "/maximo-autoscript-documentation/static/0699ff6afd2d18952674498ec9010ac0/655e2/setup.png",
        "srcSet": ["/maximo-autoscript-documentation/static/0699ff6afd2d18952674498ec9010ac0/7fc1e/setup.png 288w", "/maximo-autoscript-documentation/static/0699ff6afd2d18952674498ec9010ac0/a5df1/setup.png 576w", "/maximo-autoscript-documentation/static/0699ff6afd2d18952674498ec9010ac0/655e2/setup.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Object path format: ASSET`}{`[assetnum=‘ASSET1’ and siteid = ‘BEDFORD’]`}{`/ASCHANGESTATUS
Result: Status set BROKEN and MEMO set to Test Broken
Note: property mxe.script.callsetuponinit need to be set to 1`}</p>
    <h2>{`Testing OBJECTNAME.NEW script:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACKklEQVQoz12QW09aQRSFz9/uS5umTWPqg/alffCltk1qTawvFg8VVK7xXBADtMDx3ECgWpTLQUCuXzOjIukkK3tmJ/ubvZbSanepX91w0biicfkXr1qjaNlYtkv53KVkV6jWL3EqNYq2j+1Vsc/r2F6dau0Pzes2rU6P5vUNrcs6ysr6e16+fSf17NUq3/dUKhc1XL+KV6ni+hVcr4Lj+biej1+5kP1Go8GnrR1erKzxZu2e8Xp1HeVHaJ/QfphI9IiQGqZYKrF8JuPx4j6bzWSdz+ey6obBvqpyEIlKhX8eoKTTKXRdR9cMTk5OcByHXq8nNRgM6Pf73N7ePtQ+k8lUAgU8n8+TyWQ4O8tKmaaJkkqlZDOTMdE0Dcuy5PAjqN1uEwSBhAvgdDq933wykXOapmMYhoSl02mUZDIpH0JiQ8/zF7bEFgLwaHH5iP7p6al0J2YFPB6PP21oGCbZjE40nWc7UWU0njB/AP4v8dFoNJJzy8BEIvEEFE1huWxZdLsBnU5HWu0GAe1OIDMNgp7sidrpdDHNe6CwvAAmEskFUFj2fZ9ms4ntOLRabYZ3I5nncDhkPB5LwYy74QBDzmgPUJNYLIby+IOQCNV1XZmRGJTZSc2W0ptTaw64G8+xrRJn2SyFfI7fvwrouoYSjkQpFPLkcjmKxSLlsoV6eEz46JDI8SHqcYzdaIJdNUJIPWAnHOf5+mc2voXY3N5j88tXNj4KbfFhY5N/X9ANUiSN/GYAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Object new Event",
        "title": "Object new Event",
        "src": "/maximo-autoscript-documentation/static/e17c5e8b46f89ae59000c4120ed3dc99/655e2/objectnew.png",
        "srcSet": ["/maximo-autoscript-documentation/static/e17c5e8b46f89ae59000c4120ed3dc99/7fc1e/objectnew.png 288w", "/maximo-autoscript-documentation/static/e17c5e8b46f89ae59000c4120ed3dc99/a5df1/objectnew.png 576w", "/maximo-autoscript-documentation/static/e17c5e8b46f89ae59000c4120ed3dc99/655e2/objectnew.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Object path format: ASSET
Result: EQ1 set to TEST EQ1`}</p>
    <p>{`Testing OBJECTNAME.DUPLICATE script:`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACPUlEQVQoz32SW08TURSF52/7oiEaQ+QBeNFEXkBNJCaoD9oLUKFX2ulMC6XQezszvQAC005v0/tnzqkQY6I7WTl7n2Sts/bKUey2Q/Pmnnrrhtb1T2pWg1yhTKlco1CqkiuZWM1rKmaDy5JBuWZRLjUp1xpYjStu79rYnR63d/fY102U1Y3XrLzaZGVtkyfP1/j8zYdVb1A1LGpmHcOsU62ZVA0Tw7QwrDqGZdG6uuLd7h7PVtd5ub7UeLG2gfLd48Xj9XFw+AOP108un+dfNZ/PJWazmZxVNYnXJ7gBCf/+AUosGkVVEyQSKicncQzDYDqdSgii67osFgvZj0ajR4j7s7MzUrrO6WlaQtM0lGg0iq6n0HUdVVXJ5wvYdhvHcej1eti2Tbvdptft0nG6TGdz6U48IDgJVSWZTEqxWCyGEolE5CAQj8cxjaokTCYT6WQwGMjzwbVYWZToU6mUNCG4QjwUCj041ElqGkk1welFiWJrwHyx4H8lhP8WDIfDfwgmNXRNJaxmCaRbDF2X8XiMK1wOXUauK3NbYkS/P0DTljGJlR8Fw+GIHJYrJzBqVdxBV2Yncuw4Du2OQ6/fl5n2en3Go6Hsk5ouY1qKagSDQZSHFwREqJVKheFwiNPpyHMyHrOYjln8/iqimncukxlUy0XS6RTZ8wyXF1n5WxT/YYBs9pxMJkMul6NQLOI/CrF/fEQgeIT/OMSXQJivvkM83gP2/EGebrzn7a6H7U/f2Pnwka1tgV3ebO3wCycmDXyTJ5GWAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Object dup Event",
        "title": "Object dup Event",
        "src": "/maximo-autoscript-documentation/static/a0ef82b703df27706003c845ca014875/655e2/objdup.png",
        "srcSet": ["/maximo-autoscript-documentation/static/a0ef82b703df27706003c845ca014875/7fc1e/objdup.png 288w", "/maximo-autoscript-documentation/static/a0ef82b703df27706003c845ca014875/a5df1/objdup.png 576w", "/maximo-autoscript-documentation/static/a0ef82b703df27706003c845ca014875/655e2/objdup.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Object path format: ASSET`}{`[assetnum=‘1001’ and siteid=‘BEDFORD’]`}{`
Result: ASSETNUM set to null`}</p>
    <h2>{`Testing Attribute validate event:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACTklEQVQoz12S20/aUBzH+bf3sGxmy2LYg/qwZYkv0yyZMYvxwQSqoHIdLQUFmVzkUkAqC4KFUgqU8ll6cBo9yTe/y8n5/C45vgfDQO/2aHV6wmqtDtflKjfVBsVKnXpLp9HWua5qVOttqjWdqtamUtO4vevRux8wMEx6vT6Dbgff+uYX3vu3WPNv8uaDn4OjIM1Wm4bWQnu0da2J1mzRbLfR2m0azRb63R27e794t77Bp42vrPm3+Ph5E18gKBGUjjk9O0c6CVEslVidJa/PcvkypyhpAsEgJ6GwkHR8gi8ei5FIxEkkUiSTv9E0DcdxmM1mOAsXy5oI0GKxYD6fC+u6rvBzuRzZTIbLywshVVXxxeNx1EwGVU2TSqUol8sMDQPTHGGaJoZhiHhsmgyHJo6zEN15RTOZDLKskE6nBSyZTOJLJBLiwkvIskypUuHBmtAzV2r9vadrjITfHVrMF+4TMJvNoiiKeOsxotHoMzCdVsmqCmdygcPULdZ0zsxZMLZtJtMZ9txhPJ3jPu7RG/01MBaLvexQUWRyhRL1zgNjc8zEGmNZFsPRGHsyEfLiVW6EqmYE0Bv5CRiLxZ+AKVmm0aizXMyxbftZ0ymGMUTXdfr9AebIYNC/F0Bv7yuoSiQSwfe/gidvqbVabfVFXJeluxSWpYvrONj2RBRr6AbmZEbtpszlxQWFqzzXfwpiQp8UClMoXJHP5ykWi5QrFQLhc4KnYULnpwTPIhyEYxxKYQJSmIPjKG+39tjel9jZP2Lnx0+2v3va49v2Lv8ACrMMH7Pr+yUAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Attribute validate Event",
        "title": "Attribute validate Event",
        "src": "/maximo-autoscript-documentation/static/a46b64dc669030c6f1710dd660a351d6/655e2/aatrvalidate.png",
        "srcSet": ["/maximo-autoscript-documentation/static/a46b64dc669030c6f1710dd660a351d6/7fc1e/aatrvalidate.png 288w", "/maximo-autoscript-documentation/static/a46b64dc669030c6f1710dd660a351d6/a5df1/aatrvalidate.png 576w", "/maximo-autoscript-documentation/static/a46b64dc669030c6f1710dd660a351d6/655e2/aatrvalidate.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Object path format: ASSET
Attribute values:
ASSETNUM ATTRTEST1
PURCHASEPRICE 300
Result: Some error is thrown because PURCHASEPRICE > 200`}</p>
    <h2>{`Testing Attribute action event:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACVUlEQVQoz1WS628SURDF+bdNTNRoTNMmtn5QE/vFqok1RvulkYUCZXmlLI82FOVRoAsUKIJ2H9BlF9ifuZe21klO5mZuzrlz5k7gyjDoX45o90YMhiNaepdKvcFZ45xqQ6fdG1Jttqk2dZqNHmetC+qtNg29S7c3YDj6zR/TZiTyZY/A2tYrHq9v8WT9JQ+ebvBtX6HdvaCld9A7Xc71joTe7qB3u6tau0O/P+D97lcerW3yfPO15D/b2CIQVEIooTDR2CFBJUy1WkOE7/v4gOfNuY3lYsH90HI5gkGFg0hUIhQ+IJBQVdKpNKlkmng8TrPZxHVdZrMZnudxfe3IPJ/PmbmuzMvlUuZSqUSxUODk5Fgin88TSKVS8iCQzWap1WoYpoFpmpiWxdWVgWEYq7NpMZ+vuhSChUKBrKaRy+UkP5PJEEin0/JCFLRslnK1Rt+YMpo4jKcz9OGYS8Pm18RhYDrMl0spuFgsKBaLaJomuUIjkUj8E8zl8hwXNCKZEp/VNjPXY7GYS+tiBJ607EkhYVnUBO++YDKZ/L9DYbleP8MwLWnTti0sy5ZWJxMb27axrFXNMEzy+ZWgsHwnmEyl7gSPjo7QdZ3ReEyzdY5p2Tgzl8l0iuM4sivX88R/4zjX5CQneyOaR1VVArcvCIihtlotOSPPdfGXvtgf8Jc3i+JLXIymzDyfRr3KyfEx5dMSP3+U0bQsgVAkSrl8KlegUqlQq9VRYnHChzEiagwlrrIXTbKnRPiuHPA1pPLwxQfe7gbZ+bLPzsdPbL8T2OXN9g5/AbOwC8MursdiAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Attribute action Event",
        "title": "Attribute action Event",
        "src": "/maximo-autoscript-documentation/static/f3f02d0a56c5f940c0ebc2d413431e37/655e2/aatraction.png",
        "srcSet": ["/maximo-autoscript-documentation/static/f3f02d0a56c5f940c0ebc2d413431e37/7fc1e/aatraction.png 288w", "/maximo-autoscript-documentation/static/f3f02d0a56c5f940c0ebc2d413431e37/a5df1/aatraction.png 576w", "/maximo-autoscript-documentation/static/f3f02d0a56c5f940c0ebc2d413431e37/655e2/aatraction.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Object path format: ASSET
Attribute values:
ASSETNUM ATTRAC1
PURCHASEPRICE 100
Result: EQ7 set to 50`}</p>
    <h2>{`Testing Attribute init event:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACL0lEQVQoz12R3U/aUBjG+2/vZh/Zsi16oV5sWeLNNCZzZpsXW0aRDyktxH4gBpjaWtoCgkTUQkv5aumznBfc1JP80rfn5HnO+z6Hc90+Ot0emu1r+jqtNk51E4ZpEedmE812F4bdgtm4RN1qwax3YNQdtDrX6N26uOv76N3c4q7bBvdu/QNermzg1coGnr1exY+fPJxmC5bdgN1owW40qbacJQ2230Dn6grbu9/w4v0a3q59JP2b1XVwCT4JPnmATPYQrD7XdbAVx3PEACaTKe5XFIWYzWaYz+f0r6gqEjyPVDpDJA9S4PKCgIJUgCRKyOVyuLgw4fs+MRqNMBwOiSAIMBwGCMMIcRyTabVaRalUwslJmdA0DZwkSVQwZFmGoeskXhgM4bouPM9bmgcIo4i6C8OQzGRZgaqqpC8Wi+AKhQIdsI2joyPYtrMcedFFFC06errY/vHxMRRFIS3zyOfz/w1VVUO5pCBTrGIv38R0FlKOTPgUdtF0OiXdQ0NRFB93yEbWDQMDz0e/3ycGAw9u36NMPc+n8T06H0DTFoZs5H+Goig9GtlxHPRubmDZNonYK7M8x+MxvTADmGMyHkEljbw01SAIArj7GxgsVMuyFqGTkMIE4vmD9GJc9gJMZjFM4xwn5TJq1QpO/9SgKDK4ZDqDWq2KSqWCs7Mz6LoBPptD8jCLdC4LPidgPyNin0/jN5/C96SA5+s72PyawNbeL2ztfMHmZ8YuPm1u4y+G4A0FRtVx9gAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Attribute init Event",
        "title": "Attribute init Event",
        "src": "/maximo-autoscript-documentation/static/21298fa2ff66b9fda2e088f72d4c156e/655e2/attrinit.png",
        "srcSet": ["/maximo-autoscript-documentation/static/21298fa2ff66b9fda2e088f72d4c156e/7fc1e/attrinit.png 288w", "/maximo-autoscript-documentation/static/21298fa2ff66b9fda2e088f72d4c156e/a5df1/attrinit.png 576w", "/maximo-autoscript-documentation/static/21298fa2ff66b9fda2e088f72d4c156e/655e2/attrinit.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Object path format: ASSET`}{`[assetnum=‘1001’]`}{`
Result: EQ2 set to ASSETNUM (1001)`}</p>
    <h2>{`Testing lookup scripts:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACNElEQVQoz32SSU/bUBSF/be7KlWrisIC2MCCTSNVArWCRYVoRie2Mw8OJGEIMYntDAxhSEKlJHacr3qGoA5Sr3Se/e7z+XSPben+/pHe1Q3tzhWd7jVNq835hUHDaHHeMDGsHnanR/3SwrC6GI0Ohtmladrc9Hr07x55GDzRv7vn4bqLtLy+ydKnDZZWNnjzfpX9gyB2u+MbTKtNy7RotixMy36W3aZpWnR7VwR293i7vMbHtU3erWzwYXUdKRgKE45EiccTBMMR6vULRLmuw//Km89JJpMIfyQaJRKNEQpHkOKyjKKoqEoKVdVoNpu4rst4PGE2m/maz+f+1XEcptOpvx+Px5SKRcq6zlG5zNFRmWKxiCTLMTQtiZZMEY8rGIaB53lMplPGE4fJZOJP9DdQ9PP5vK9CoeDD0uk0klh0XUfXS/5hq9XyTWJKARYSsMX9ogRcQBbAUqmEqqpI4j2IA9HM5XKcnZ1z279jOBwyGo0YDAa+RqMhj4MhjuO+QqvVqu8RfgHUNA0plUr5G9HMZrPYlvlPxN8nFHE9b+4/U6vV/gWKZTFhsZAjWz5DO+kzdUTkGY7r4rri43gvmgFzX8fHFTKZzEvsIoqiIGXSaT+7UCIuky3VOLGfXqd4rvkfv4x9+xPHg8tGnXJZp1atcHpSI5/PIYWiMWrVKpVKhdPTUwyjQSKpEZJjRBWZHwmV/ajG91CMb4dxghGZle09tnYOCXw9IPBlh+3PQrtsbQf4BVv7Dr/G2ikbAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "lookup Event",
        "title": "lookup Event",
        "src": "/maximo-autoscript-documentation/static/cab7f0b0b980c7459a0b3669cefeaedf/655e2/lookup.png",
        "srcSet": ["/maximo-autoscript-documentation/static/cab7f0b0b980c7459a0b3669cefeaedf/7fc1e/lookup.png 288w", "/maximo-autoscript-documentation/static/cab7f0b0b980c7459a0b3669cefeaedf/a5df1/lookup.png 576w", "/maximo-autoscript-documentation/static/cab7f0b0b980c7459a0b3669cefeaedf/655e2/lookup.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Object: ASSET
Attribute: EQ11
Object path format: ASSET`}{`[assetnum=’ASSET1’]`}{`
Result: Values for lookup will be from ALNDOMAIN PHONETYPE`}</p>
    <h2>{`Object Structure Script Processing - Inbound:`}</h2>
    <p><strong parentName="p">{`Function: beforeProcess(ctx)`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACLklEQVQoz32SWU8aURSA53f3pTYxTdU0pQ+2D75oYrroi2lKZZiFZVg67ALKMjNUoLjgWkBmygBfwzXti9WTnJyTm5wv3zm50vXtL3rnV3R653R7p7S7Jxw1LJrOMfWmg+0c07RbNJwOp/0rOid9rHYP2+rx8+ySi8sbrm+HXFxccX3WQ3oVWGdpJcDSaoBny2vs7AWxnBZ1y6FhOQJab9rUmxa1hvWv/9E+ZvPDDs9XArx8844Xq29ZXgsgheQwclhFj8QIyQq1eh3mczzX5bGYA7M5pFIpQrKMoqooqoYcVpAiuo6m6iiKhqqotFoOs9kMz/NEnc/nD3IRE9+nVCxSKBRELZWK5HI5JCWsoIQ1wrKKpqnYtn0/MJmIFEb/AU6nUwEzTZNsNitgC2NJ1zWi0TiGkSaZTNPptMWA67pPAn3fJ5/Pk8lkBGzRx+NxJE1RSRgpotEESSPOwWGT7qWH70+ExVNRKpWE4V+gYRgLQ52IHmE/pCCHFMx8hUb3lt+eJ+7ouh6jO1f0C+P7t4W9T7lSeQhUhWGSaMQQlo7tMJ14DIZDRqOhqIPhiMFgwHm/z2AwxBvfMR6PKR0ckE6nxdrZbI5YLIaUSiQwv2cwzQzpVJJWq/X4d5ne3/TsxsWfgWM1KBYLVCtljg6rZDImkqzqVKsVyuUytaMa9XqDoKLxTVUI6ypBLcKuHGVvX+FzUGc/rPF6Y5f17S9s7nxla/sjG5uL/MT7jS3+AEiyDFDPEBh7AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "before process os Event",
        "title": "before process os Event",
        "src": "/maximo-autoscript-documentation/static/b69238e61d94e61269e9af35375571af/655e2/osbeforeprocess.png",
        "srcSet": ["/maximo-autoscript-documentation/static/b69238e61d94e61269e9af35375571af/7fc1e/osbeforeprocess.png 288w", "/maximo-autoscript-documentation/static/b69238e61d94e61269e9af35375571af/a5df1/osbeforeprocess.png 576w", "/maximo-autoscript-documentation/static/b69238e61d94e61269e9af35375571af/655e2/osbeforeprocess.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Use the “select file” option to select a xml or json file:`}</p>
    <p>{`Test XML: MXITEM1.XML
Test JSON: MXITEM1.JSON
Result: Transaction is skipped for LOTTYPE=NOLOT`}</p>
    <p>{`Object Structure Script Processing - Inbound:`}</p>
    <p><strong parentName="p">{`Function: mboRules(ctx)`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACJ0lEQVQoz3WS3U/TUBjG+297JUZjBC6cF6JRE4kkQCAxJspHt3YDxjbajlG3ydp13QdzfG8gHXZbt/3MKcIFyps855w+yfn1ed9W6lz+onXS5qB1QrN1RKN5yL7tUHbrWGWXilunXKliuwccnbY5ODyl0mhRcVr8PG5zdn5B59Lj7KxN57iF9CLymonJCBNTr3j0dJqlLys4bg3LcbEdF6tc+SuHku3cnWuNOrPzSzyejPD85QxPpl7xbDqCtL4usy4rxBMbRGMKlmUjyvd9xuMx/yvhjsaQTqcR92OKQkxRkaMxpNT2NrpmoGsaO5kMtVqN0WhEv99nOByG0PsSNQgCzL09crlcuJvmHtlsFikRT6CqceSowtpaFMsq31wYDMKUAh6mugcULxMwTdMwDCOEicSSqqqkUulQyWSKRr1213Kv13swYRAE7O7uout6CBPnra0tJLEIQ0jXdiiUHJrnPYJgcJfuoTJNM0x4C0wmk0hiEYYhoIZOLl/Cbl7Q7/fChL7fo3t9k1bMVUh4YiT5QuFfoEgoHoS5o2nUqi7BoMeV5+F1vXC/8rp4nkencxHqunuF7//GNL+TyWTCtg0jy+bmJtLtUIXEUKvV6sM9jofih+G44xOMwHXK4RcuFvLs/yii6xqSrKgUiwXy+TylUgnLtlmJqawqMeR4jFU1wXJ0g8+rMssrcb4pG0y+XWRmYY255a98nJvn3ewiH2YXePP+E38AU/MOWWySG/4AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "os mbo rules",
        "title": "os mbo rules",
        "src": "/maximo-autoscript-documentation/static/77c40689b7eda39a57c989945354ea90/655e2/osmborules.png",
        "srcSet": ["/maximo-autoscript-documentation/static/77c40689b7eda39a57c989945354ea90/7fc1e/osmborules.png 288w", "/maximo-autoscript-documentation/static/77c40689b7eda39a57c989945354ea90/a5df1/osmborules.png 576w", "/maximo-autoscript-documentation/static/77c40689b7eda39a57c989945354ea90/655e2/osmborules.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Test XML: MXINVISSUE1.XML
Test JSON: MXINVISSUE1.JSON
Result: Transaction is skipped for ISSUETYPE=RETURN`}</p>
    <h2>{`Testing object structure inbound:-Functions: beforeMboData(ctx) and afterMboData(ctx)`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACSklEQVQoz4WSW08aQRiG93f3orWJaaJtUrzoIfGitmlr09qLxiin3dkF5LAcRBBd1+UkoFYMUmEpsCBPs2sgNWnSSb7MN4f3me+dGemq0+P8qkvrok2rdUH1rEW9eclprcWR0cAwy1StCtV6k0rjgnLjknqzSblR5rJxTvu6w81tn2u3/3mOtOJ7xdKKj6VVH4+WX/Dtxw4np2UM08IslzGtCoZV8eZM6z7cQ2q1Bu82t3iy4uPZy9c8XV1j+bkPyR8IEgzJCDVCIBjm2DBw23Q65X8tmUzh6sOyTFhWCIbCSJqqogoNRdEQiqBWq3mbR6MR4/GY2Qxms9mDmK/nclny+/sc5PMcHOTJZrNIiiwjlIgHVFVBpVJZCIYjx8v/BXQPS2cypNNpMpmMB0skEkhCURAigqbF0VNJ9PwJuXKX2eyO6Z1X3gIyh8+Bmb+AuVyOaDSKpIRlYtE9VFVDFYLS0TF9+zeDwQDbtun1+3Rve9h23xu7MRjY3Nx0Sem6B5sDY7EYkhACTdMIBgV+v+JZdgWdTofJZMLYtT4c4jgOvV7Py93q3HGhUEDXdc/uAijLMslkkng8QTS6R71+RrvdxrIsnInjvfZwNMKZTDzI2Jm4xr0rKRSLnvbedpZIJIKkp1KLshOJONVqlenEYWDbXoWumNndg+9y/WuEM4WKZXKQ36d0WOT4qEQ6rSMFZYVS6ZBisYhhGJyYJruyIKDIhITMrqKyFdL4vhtkeyfAll/l8don3nzeYePrNu8/brK+4cYX3q5/4A8z+QsZgW5QPgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "beforembodata",
        "title": "beforembodata",
        "src": "/maximo-autoscript-documentation/static/0908316f2eeace020eb442607f32dcc3/655e2/beforembodata.png",
        "srcSet": ["/maximo-autoscript-documentation/static/0908316f2eeace020eb442607f32dcc3/7fc1e/beforembodata.png 288w", "/maximo-autoscript-documentation/static/0908316f2eeace020eb442607f32dcc3/a5df1/beforembodata.png 576w", "/maximo-autoscript-documentation/static/0908316f2eeace020eb442607f32dcc3/655e2/beforembodata.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Test XML: MXITEM2.XML
Test JSON: MXITEM2.JSON
Result: Set COMMODITYGROUP based on HIERARCHYPATH`}</p>
    <h2>{`Testing Object structure inbound function: changeStatus(ctx)`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACUElEQVQoz32QTU8aYRSF53d3U5uYpmrS0kVt0nahiWkbXbRppMJ8MToIDohQUIeP4UMUFBFEcIBhgKeZqXXRxJ7k5N7N+7znXKHbu6PR6lBvtDhvXHJ23sQsWJTKNfLFMla5RtGqUCjXubzuUG9eY501sEoNLq5uaN/c0u0NaLc7dK8aCK8C71hYCrCwHODZ4gqb37YxiyVOCyUKVoV80XpwCbNQetwrtRprnzd5vhTg5ZtVXiy/ZXElgBAKi4RFGTWySygsYZp5PE0mE+bzOf/TgWGwEwojyYrvsCghRFQVRVaRJAVZkqlUKo9Ax3F86L/25LoumUyGo6MjMuk0mUyaw8NDBEmUkEQFUZRRZJlqpew/GA6HPtDTU8BUKoVhGCSTSR8Wi8UQVFVB0/bQ9TgH8QNypkW9PcJ1J0yn0yfrzmYzP10ikfBhHnxvbw9BkWSiegxN09mP6iQzJxQv7pi6k8fa9nCEMx77+/hheg0OUykfmEz+Aeq67iVUiagRQiGJYFCkWCjgjGza7TadTofbXo/+4B7btun3+/4cDAbYwyG/slm/8t+EPlD2E+6jRXQ0LUq1dkaj0eTUNMnn81y1Wkxcl9FoRLN56X901+viOGOyuRzxePwx5e7uLkIsGsU4SGAYCWKxfarVKhNnzNC2/Zpz/45z5rMp9qCPfT+gfNFh5MwoW0XS6SOOc1lOT45JJAyEsKxyfJwjm81innqpCvyUI4QUGUlTCKoaW6LG9x2JzaBKWFJ5/WmL1Y0frG1us77xhY9rnr/y/sM6vwFEcAljbtKIJgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "changestatus",
        "title": "changestatus",
        "src": "/maximo-autoscript-documentation/static/1bcd903f1f6b179e8899b288329d4c7e/655e2/changestatus.png",
        "srcSet": ["/maximo-autoscript-documentation/static/1bcd903f1f6b179e8899b288329d4c7e/7fc1e/changestatus.png 288w", "/maximo-autoscript-documentation/static/1bcd903f1f6b179e8899b288329d4c7e/a5df1/changestatus.png 576w", "/maximo-autoscript-documentation/static/1bcd903f1f6b179e8899b288329d4c7e/655e2/changestatus.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Test XML: MXITEM3.XML
Test JSON: MXITEM3.JSON
Result: Change Status with MEMO`}</p>
    <h2>{`Object Structure Script Processing - Outbound`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACTUlEQVQoz22Q62/SYBTG+2/7SY3GTPdh84OXZF+cMXGLxmgctDBKBwxGuQ5WBMalA4RhxqCwUW6Fn+mr21ziSZ6cvqc5vzzPkfrWkPavPo3WOe3zLvVGi9JpjXKlLlSpmRRPTerNDu1uj0qjTbXSpmr+pNnpcXE5oG9dcdG7pN9tI61tvuLR800ev3jJgyfrfPmuYDaa1M+at/2s0aJWN6nWTTEzm006nXPe73zm4doGzzZei/2n65tIiuLD598nqGmiF0sl3FqtVswXDrPZ7Pa9WCxYLpewEiMSiSSyorAfUIXcfekwcogWDKJpIQ4jR9RrNebzOY7j8L9ywTfwXC5HJpPm+DgrlEqlkDQ1iOz14vHIqGqIcrmCbdtMJhMBdh1Op1Pmos9wnKUAu8B0Oo2u6ySTSQGLxWJIWlDD7/Mjy34CaoRCochgMGA0GglZlsVwOORqNGI4HLFYOPeAiURCwNzvcDiMFNgPoMgKnj0FWVapVKpiwb2Vu+S6FHe7C337P5vNout3wEgkghQKhYjH40SjR8RjR2hxA2+qy8JZ3rvbv7X8+zYMQ0S+B3RtZjIZMUilEuQLJWqtCwYDN6qFZQ3p9f/EHliWOIF9PWI8viZ7nBNm3NjJZArXnKTrN4Mk0WgM06y7HrDHYya2jTOfw9Jh5ThMJ2OmE5ta22IyW1KrlMlmMxgneX4UDBIJHckXUDGME/L5PMVikXL5FFk9wK8FUUMaykGYr2qEb74AX5QQnmCEtbe7bO162f60x/aHj2y9c7XDm61tfgOBiAuO5KeNxgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "os out",
        "title": "os out",
        "src": "/maximo-autoscript-documentation/static/23d46a09a6667449108dc037f19f1505/655e2/osout.png",
        "srcSet": ["/maximo-autoscript-documentation/static/23d46a09a6667449108dc037f19f1505/7fc1e/osout.png 288w", "/maximo-autoscript-documentation/static/23d46a09a6667449108dc037f19f1505/a5df1/osout.png 576w", "/maximo-autoscript-documentation/static/23d46a09a6667449108dc037f19f1505/655e2/osout.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Object path format: PO`}{`[ponum=‘1002’]`}{`
Result:
Set description
Skip POLINE without ITEMNUM
Skip TAX fields if TEXED is false`}</p>
    <h2>{`Object Structure Query:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACZklEQVQoz22R2U8TURTG59/2SY3GIDyADy4JL2KMEkOUGKQzt1M606kUSqG1ZeuS7qxdZgYos3Tan5kRSIze5MuXe5L7O+c7VxpaNicXQ1qdM07OLqg3OxxVahxX65Srdaq1BkeVBvX2Kd3zHtVWl1r1hFqjS/u0T29gMrSu6fUHDM9PkGYWXvPk5QJPZ1/x6Nks39Zk2p0uzVaHZrtDI/RWm3qzRaPZuqu1OD0748PyCo9n5nkx/yZ6/3xuAUmWBbKIk9Q0RFzl+LhMeFzXxfc9ptMp/zuTyRQjnUZWBHFVJa4mUEQcyUil0JM6umZgGGmazSbjIMD3faZ/ASaR3zcIG+ZyOfJ7exTyeQqFfHSXhCKQY4LYjwSxmEq5XMFxHFzHYez7eJ6H57lRzXFcguAPOKzv7OyQzWYjD2Gbm5tIQlZYX48hRJJMZptKpczQHDKw7EiXgyED0yL8vJ5p44/HDxPew0Lt7u6SSqWQ4kIg4oINTSOd/km2cECpPWQwcjFvPS7t68hNx6M/8ggm04foYczt7e1ouhBoGAaSIiusrq6yvq6STBgoqTxrW11c1yMYj6No4TRj34v26t+tIQgCSqXSv0AhBLquo+sGmpaiVq3ijK7p9Xr0+31M04zi2rZNvz/Asixub64Y3dxQKPwik9m6i56LOFI2e98hRyaTodFo4LkutmVhWza3oxuYTiKNrq9wbkfUuiaOP6Feq5DP77FfKnJ4sE/IkhQ1wX6pRLFY5OjwkHK5jLyhI7QkG4aGrBt8VQ2+KwlWZB1F1ZhbXOHdpzWWvqyx9PEzi+9DLfN2cYnf5GMIlN5NA9oAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "os query",
        "title": "os query",
        "src": "/maximo-autoscript-documentation/static/ecc896ea2d6cb52e48e6e36cf6f3f210/655e2/osquery.png",
        "srcSet": ["/maximo-autoscript-documentation/static/ecc896ea2d6cb52e48e6e36cf6f3f210/7fc1e/osquery.png 288w", "/maximo-autoscript-documentation/static/ecc896ea2d6cb52e48e6e36cf6f3f210/a5df1/osquery.png 576w", "/maximo-autoscript-documentation/static/ecc896ea2d6cb52e48e6e36cf6f3f210/655e2/osquery.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: OSQUERY.MXAPIWO.EMXWOFILTER
Object path format: WORKORDER
Parameters:
ASSETNUM 11200
STATUS WAPPR
Result:
Where clause applied to MboSet (assetnum=‘11200’ and status = ‘WAPPR’)`}</p>
    <h2>{`Object Structure Actions:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACY0lEQVQoz3WS228SURCH99/2SY3GVPtgffAS+2Kj8Ro1aaqwwC4sJWyAtrRQqQvlsmyhFXrZGxR2Fz6zRx/UxEm+zJxJ5nd+c3KkS9th8OMS0zplcHpGp2dx1GxjtDo0j7u02l2Oml06/SEnZ2Na5gnHrQHH3RP6wzHjiysubY/x+QWXZwOklbXH3Lq/xu0Hj7hxZ5XPW0nMvsVxpydod016pkWnZwp6fYuOaTIYDnn57iM3Vx5y7+ETMX93dQ0pKaeQUxlUNUdcfzcM4giCOWEYslwu+F8UdZ1EUiadyZDOKMipNJKW01BVlVxWQ1GytNsdFouF4M+Iz2EU/r5kSRAEVKtV9vb22K9W2d+vsrOzg6QqKnIiydaXJKlUDsMwmPg+04nP9XTC9XQqat9zsa9sZrP5L8EwFGKlUolKpSLEisUikhpbTSTY3PyKLGvUDxsMx+eMbZdzx2M4vmB05XDu+owcnzD65Tx2uru7S7lcFmJxnc/nkXK5HLquUyzqlHQduXDAm4KFOwuZRgvcWYAfREzChSCKn2K5JIoisfKfgtvb20iFQkFYjxuVSpnGd4PRhYPveUx9X6zvOJ7IvuviuS6O4+BPptRqdbHyX4KapolG/A6xU9M0cRwby7IYjUbYts1sPhe4nsdsNoNlRBSFHBzUxEzsslLZIdaS9GJR7B6jKArNZosoDAnmc5Fj+Ofr9EcTggjaLYNqdY/Deo3Gt0PK5RKSnFE4rNep1WocNRoYRpOkqpHKqij5LEktz6fMNpuywvuvWZJpldXnH3j2eouND1tsvHrD+ouYtzxd3+AnjGUJ9bgP7VwAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "os actions",
        "title": "os actions",
        "src": "/maximo-autoscript-documentation/static/c38c4cadc776603cb658fc62646646ee/655e2/osaction.png",
        "srcSet": ["/maximo-autoscript-documentation/static/c38c4cadc776603cb658fc62646646ee/7fc1e/osaction.png 288w", "/maximo-autoscript-documentation/static/c38c4cadc776603cb658fc62646646ee/a5df1/osaction.png 576w", "/maximo-autoscript-documentation/static/c38c4cadc776603cb658fc62646646ee/655e2/osaction.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: OSACTION.MXAPIASSET.SETPRIORITY
Object path format: ASSET
Parameters:
ASSETNUM 11200
STATUS IT
Result:
Sets priority based on the ASSETTYPE`}</p>
    <h2>{`Event Filters For Publish Channel:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACQ0lEQVQoz32S7W/SUBSH+49rNGoWp5lucdFkXxY1RjPjBzM3GZTxToCWvTFlGdB2DIQxXkrLKKXsMfcixn3xJKen93dznnvOuVcZDIa02tc0mm2seoOKYXFeNSifm1StJvVmm7Oqyc9zi3LZomLWqdQsquYFtfolV9c9egOHTqdLr9VAWXqxzoPlVe4trfB07Q1HJ6dUDYuaaWGYF/JfxJppUjVMqjVD7l02mhQPT3j0fI0nK+s8XF7l8bOXKN9De4TCYcIRlf1YHMdxmM1m3N7esjB/OsObTKTmTyZMp1Opdzodvu3sylzhob0wSjwWI6pGicXSZDI5hsMhvu9LqIjTIGAazA9YHDL7E+v1OrlcjqPDQw4PDtA0DUVVVRKJJMlUlmw2R6PRZDCwJXgwGNDtdrFte665IwlagA3DIJ1OS5DwTCaDIj7FYhFNK0jR91yRIlscj8eMRiPZovAgCCRMVL8AinyRp+s6iUQCJZVKoWk6hUIBXdc4qnToDP15JfzfRMuLCgUwmUyiCEEsBLCoa+xkK5xd9Aj8eYWe5+GOxtzcjJlMPLkWuphvq9W+U6EEJpOpv0CxMXZtJt5Y3rbrujI67gjHden3+/R6fYZDm6nv0Wj+khXm8wUKBY14PI6Sz+clTETh4gLu2D/Ph1kgB9F3PK5sH9ex0TWN09IJP05L5PM5lFBEpVQqcXx8TLlclnPZVfcJRVUi8Si7sQRfIgm+hlS2dmJEojHef97m/qstPm3vs/nuAxubH6W/3njLb6lJEvK2deizAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Event Filter",
        "title": "Event Filter",
        "src": "/maximo-autoscript-documentation/static/c7cbc96f3b28061c1139f2c82ffbac19/655e2/eventfilter.png",
        "srcSet": ["/maximo-autoscript-documentation/static/c7cbc96f3b28061c1139f2c82ffbac19/7fc1e/eventfilter.png 288w", "/maximo-autoscript-documentation/static/c7cbc96f3b28061c1139f2c82ffbac19/a5df1/eventfilter.png 576w", "/maximo-autoscript-documentation/static/c7cbc96f3b28061c1139f2c82ffbac19/655e2/eventfilter.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: PUBLISH.MXASSETINTERFACE.EVENTFILTER
Object path format: ASSET
Parameters:
ASSETNUM 11200
STATUS IT
Result:
Sets priority based on the ASSETTYPE`}</p>
    <h2>{`Exits for Publish Channels External Exit:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACN0lEQVQoz22S7U8aQRCH7x9vk6ZtTF9irGnTpn6ojWlM26Rp+iIiCByojQeIRGlJEbnj4HhTvOMQjuOOp9lVGk07yW9nMsk8OzO7im0PaHfOaFodDLPJyalB5aRGuVKjaliYVodyVedXRadcNqjUTE5Odap6nVOzQfesT9926fXO6bebKAtLL7j3+Bl3FhZ5tPyKo1IZvW5SM0xqukG1ZqAbJnq9Tq1ev4oNk0bT4uDwiPtPl3m4eMV48GQJJbIZZXMrRiy+TTKlMhgMCKZTZmHI3PxpyGQyIQxCPM9jOp3KfLfX4/tGRNYKRbdiKGlVJZlMsB1PklZ/SKDv+4RhKL0ACWAQhMxmM5kPry+zLAttf5/i4SGHhQK5XA5lZ2dHBlo2K32r3cZxHFzXlXDbtqUXcocjCRJgYY1Gg93dXVkntLe3hyIS+Xye7DVwNHSYhQHj8ZjhcChBokvPm8hR513OgQIi6gQjnU7fBubzOX7Xz3FGwd9O5t38z1qt1i1gJpO5DTzI5/mcqVA2bZgFeGJ/vs9o7DH2PBkLyYcJAjqd7r9Acdwc+dK16Z/3aLc7clyxT2fgMnBd+v2+1OXQxZ+MaVqW3KGmZclmc6iqipLVNAnTrr0E2Db2xcXV17nxfQjFKmY4lz5dx2foDuSaSsdH/Cwdo2n7KJGtGMVikUKhQKlUQjcMogmVWCpJPJUgklL5FE/zJRrn40aSeCLF2sev3H3+gfffEqyuvWNldZ2VN+u8fP2WP0ejErNVNQ4zAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Publish Exits",
        "title": "Publish Exits",
        "src": "/maximo-autoscript-documentation/static/3907b74010e4c7bb751a6bfd2440326a/655e2/pubexit2.png",
        "srcSet": ["/maximo-autoscript-documentation/static/3907b74010e4c7bb751a6bfd2440326a/7fc1e/pubexit2.png 288w", "/maximo-autoscript-documentation/static/3907b74010e4c7bb751a6bfd2440326a/a5df1/pubexit2.png 576w", "/maximo-autoscript-documentation/static/3907b74010e4c7bb751a6bfd2440326a/655e2/pubexit2.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: PUBLISH.MXASSETINTERFACE.EXTEXIT.OUT
Object path format: ASSET`}{`[assetnum=‘1008’]`}</p>
    <p>{`Result:
Set description to status if status is OPERATION`}</p>
    <h2>{`Exits for Publish Channels User Exit Before:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACN0lEQVQoz22S7U8aQRCH7x9vk6ZtTF9irGnTpn6ojWlM26Rp+iIiCByojQeIRGlJEbnj4HhTvOMQjuOOp9lVGk07yW9nMsk8OzO7im0PaHfOaFodDLPJyalB5aRGuVKjaliYVodyVedXRadcNqjUTE5Odap6nVOzQfesT9926fXO6bebKAtLL7j3+Bl3FhZ5tPyKo1IZvW5SM0xqukG1ZqAbJnq9Tq1ev4oNk0bT4uDwiPtPl3m4eMV48GQJJbIZZXMrRiy+TTKlMhgMCKZTZmHI3PxpyGQyIQxCPM9jOp3KfLfX4/tGRNYKRbdiKGlVJZlMsB1PklZ/SKDv+4RhKL0ACWAQhMxmM5kPry+zLAttf5/i4SGHhQK5XA5lZ2dHBlo2K32r3cZxHFzXlXDbtqUXcocjCRJgYY1Gg93dXVkntLe3hyIS+Xye7DVwNHSYhQHj8ZjhcChBokvPm8hR513OgQIi6gQjnU7fBubzOX7Xz3FGwd9O5t38z1qt1i1gJpO5DTzI5/mcqVA2bZgFeGJ/vs9o7DH2PBkLyYcJAjqd7r9Acdwc+dK16Z/3aLc7clyxT2fgMnBd+v2+1OXQxZ+MaVqW3KGmZclmc6iqipLVNAnTrr0E2Db2xcXV17nxfQjFKmY4lz5dx2foDuSaSsdH/Cwdo2n7KJGtGMVikUKhQKlUQjcMogmVWCpJPJUgklL5FE/zJRrn40aSeCLF2sev3H3+gfffEqyuvWNldZ2VN+u8fP2WP0ejErNVNQ4zAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Publish Exits",
        "title": "Publish Exits",
        "src": "/maximo-autoscript-documentation/static/3907b74010e4c7bb751a6bfd2440326a/655e2/pubexit2.png",
        "srcSet": ["/maximo-autoscript-documentation/static/3907b74010e4c7bb751a6bfd2440326a/7fc1e/pubexit2.png 288w", "/maximo-autoscript-documentation/static/3907b74010e4c7bb751a6bfd2440326a/a5df1/pubexit2.png 576w", "/maximo-autoscript-documentation/static/3907b74010e4c7bb751a6bfd2440326a/655e2/pubexit2.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: PUBLISH.MXASSETINTERFACE.USEREXIT.OUT.BEFORE`}</p>
    <p>{`Test XML: MXASSET1.XML
Test JSON: MXASSET1.JSON
Result: Skip transaction if STATUS=BROKEN`}</p>
    <h2>{`Exits for Publish Channels User Exit After:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACR0lEQVQoz4WR208TQRSH99/2SQnGoDwAD6gJL4gxYDQhRiMttIV2u0B3t6U36Y1ub3RBe293W7q77Wd2QRF9cJJf5sxMznd+54zQ7Q9pfu9Qbeg09WvKlTqFkkauWKZ0oZEvVdHqOlpDp6BdUio2uSg3KVYuaeg/aHV6dPsjWu0O3esmwtLqOk+er7KwvMajxWV2v/ip1upo1TqVWoOKF9c8Vet1qg33roau62ztfOTx0grPVl6y8GKNp8urCHs+Pz7/AcHQEXv+fXL5PPP5jNnM4X9LlhX2fD4OAkFP/v0DBDESQYpKSFIMUYxSLBYwxhMmN1Mcx8a2bSzLutttnNmM+XzuKZvNEo/HSSaTJJNnqKqKEI1GvUBVFWKxGPl8nlarTb/fZzAY0Ov17uN+H8u+de4WcGGxmIyiKB7j+PgYQZIk78G9OD09pVateAkzx/GcTaeuU+fO1a27X8BEIoEsy16uy4hEIvdARVGJKzJSPMdhpo3jzLzEu/x/llskkYg/AIqi+AdQVVEUGTV1TkZrYRgmpmliGAaDkYFpGt7Z1chw4zHJVMob0wOg+xF/t+xYE7rd7m/gcDjCHI+5urqm3e4wnZhY0ympVJqTkxPPpdthOBxGuD0ontyhaloFa2oxHAy8GTq2zdy23OYZGyOmNxMaLRPLgXKpQPLsjGwmzfm3LLIcQ/AHgmSzGdLpNLlcjkKhiC8UZv/okEA4hO8ozG5Q5JMvwK4/wteQyOL6Nq/f+3n74TObW+/Y2NxmY3OHVxtv+Amq2w1XfhcNdwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Publish Exits",
        "title": "Publish Exits",
        "src": "/maximo-autoscript-documentation/static/958d87b9375ae69da005922a9db43a13/655e2/pubexit3.png",
        "srcSet": ["/maximo-autoscript-documentation/static/958d87b9375ae69da005922a9db43a13/7fc1e/pubexit3.png 288w", "/maximo-autoscript-documentation/static/958d87b9375ae69da005922a9db43a13/a5df1/pubexit3.png 576w", "/maximo-autoscript-documentation/static/958d87b9375ae69da005922a9db43a13/655e2/pubexit3.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: PUBLISH.MXASSETINTERFACE.USEREXIT.OUT.AFTER`}</p>
    <p>{`Test XML: MXASSET1.XML
Test JSON: MXASSET1.JSON
Result: Display STATUS from IR record and EQ3 (set in before exit) from ER record`}</p>
    <h2>{`Enterprise service External Exit script:`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACLElEQVQoz3WR60/aYBTG+3fvy1xizNQPwyy7JC6Zmm1mbjFLNpC2gBe8cSkCorRSaUEg3lBw3KSU3/JWJbu4kzw579v0/PKc55WuG01Ozy8pV2pUa6eUyhX0gsVxqcZJ7RyjWEbXSxjmCYViCat0gl2uYtoVqmcXXNSvuWr85OKyztVpFem57xVjkz7GpmZ4Mj7N0jc/RuGYQ/2Ig7yBbpgYBRP9qOB9F8ofmRQtm/cfl3g66WPixWueTc0wPu1DCsoKsqISWV0jqKjkdR1R/X6fXq/HwHX5X8UTCVaCQdRQ2JPgSJvRKOFwGEUOEVyJYBVt7+dOp0O328UdDhn+JVGO45BJp0mlNNLpPU/JZBJJVVRkWcbvDxLwK2gZnUr9lqHrjoYfK7FBPB73lEgkPNj29jbS1tYWqVSKpKahJeNo2TyHdp1er+s5FE5b7Tu3IgLRb3s9bm5uRjAhTdPY2Ni4Awq60O7uLrZVhKFDu932YKK32x3v3Gw2PVCr1aLRaBKL/QmMRqN3QHF5AFq2/ciCQ1zXZTAYeBJRiJXFnHApZkfAaHRzBIzFYliWNRp+6P2+4wEGA/f+1Ydexplslp2dnfvVk6yvryP9noMI1TTNfw26A1zHGV3PGrf0XTguGKT3UuT2sxwe5IjHY0hyKEwut082myWfz6MbBn41QiCkIkdUAuFVviprLAcUvvgjLPsVJl4u8ObTD+aWvjP/YZHZuUXezX/m7ewCvwCqhQ3BgipxhQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Ent Ext Exit Exits",
        "title": "Ent Ext Exit Exits",
        "src": "/maximo-autoscript-documentation/static/d3eef1dc94b88474370c40262654f227/655e2/entextexit.png",
        "srcSet": ["/maximo-autoscript-documentation/static/d3eef1dc94b88474370c40262654f227/7fc1e/entextexit.png 288w", "/maximo-autoscript-documentation/static/d3eef1dc94b88474370c40262654f227/a5df1/entextexit.png 576w", "/maximo-autoscript-documentation/static/d3eef1dc94b88474370c40262654f227/655e2/entextexit.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACN0lEQVQoz3WRa08aQRSG93f3S2N6SVubFD/UNPVDjY1tU5umSQOCghZBYHdBECmXZSl3BeUmi1xXnmZGaWsaT/JmZ3ZmnvOec5RO75J6s02l3qRaP6NcPSWdM8kXSmTzBcxCCcMsYhQqnJ23qZw2Mct1zHydWqPNRatLp2dxcdGm06ijPHOssvTCwdLyCg+evGTrmxPDLJDO5skYppQAZ408mVyerNgbJr9KJd5tfubhcwdPXwnGCo+XHSiu7W1cbg9e3z5Ol4d0JouI8XjMaDTCtq+5LzRNZ9vtZtfrk/Ls7KKEQiF0TZOHoVCYYrEkL0+nUyaTCfP5/D+JsG2b4+MER0cxEom4VDQaRTk8PCQWixGLRVHVCKXSDXA4HDIcT+V6Afl3LZJp0oiGrusSJswpwWBQbnQ9SkzXiBxl0IyOeCrLvc+hAArQAihMHRwc/HUooKqqYhgGV1dXWJbFYDCgb1l0e30GliX/9W+/7XaHiKpK2AIYCATuAiORm5K7nQ6VSoVqtUqr1ZLDET3tdrsyyWw2YzKZEo/HpUPx9g8wEAjeAZbLZZrNJsVikVqtJiEjOfExjUYTyxrIdszn1ySTScLh8G3ZUfx+P8qiB0KiqQJkz6b0Ly+xZ/ZiFGIaTMcjuLY5740RR2Y+RyIeJ3WSJP0zhaapKB6vj1TqRGbLZDJkszlc3j3cPi87e16cvn2+7Pzgq8vDlnMPp8/Po9UtXn9w8X7rO+sbm7xd/8ja+iferG3wG4FKDHWCPsZ7AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Ent Ext All Exit Exits",
        "title": "Ent Ext All Exit Exits",
        "src": "/maximo-autoscript-documentation/static/9a74822d99360017bc32891a96aea939/655e2/entextexit2.png",
        "srcSet": ["/maximo-autoscript-documentation/static/9a74822d99360017bc32891a96aea939/7fc1e/entextexit2.png 288w", "/maximo-autoscript-documentation/static/9a74822d99360017bc32891a96aea939/a5df1/entextexit2.png 576w", "/maximo-autoscript-documentation/static/9a74822d99360017bc32891a96aea939/655e2/entextexit2.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: SYNC.MXITEMINTERFACE.EXTEXITIN`}</p>
    <p>{`External System: EXTSYS1
Test XML: MXITEM1.XML
Test JSON: MXITEM1.JSON
Result:
Skip transaction if LOTYPE = NOLOT
Skip transaction if ITEMNUM is null
Set description to ITEMNUM`}</p>
    <h2>{`Invoke Channel Scripting`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACV0lEQVQoz4WS208aURCH+bf70tbENLY+qE3aJvpQa9PU1CbGtIlc5I4IiwgCVkDYmwIq12WXiyzwNXtobH3qJL+cX+ZkvszMOa5u16B210G9rlOr31JVdEpXMsVylatKlWJFRdbrVLUapfINFa1ORb1BVnVu7lrct7p0eibNVpvObQ3Xyvo7Xr5eZ2n1Lc+WV9n/6UHVr6kqGop2jaLpyKqGrKioui6kqDq1eoOd3e+8WFnj1dp7lt5ssLy6juvQ7cHt8eIPBDl0eykWizhh2zb/CymV4tDtxnfkF/J4fbhCwSDBQIhIOI7PdySAk4nNYDhmOp1iO7LthbdtZrMZ8/lcnPl8nnQ6TTabETo9PcUVi8WEcZRMJgSw3W5jGAaG0afb62E46jveYGJPHydwYElJIpVKifp4PI7r+PhYXDgJSUpyUSxR6/S5N0c0jCG1jiF80xpx2x9hT2cC6HR8dnaGJEmi1mFEIpG/wFTqlExawh/PsxfVGT9MRBeTyeJceGf0xchO3qn7FxiNRp92mEwmKZbK4huYpsnAsjBNi65hYglv0u/36RmGyGfPz0XNE2A0GnsEJhIJNE2j1WqiKAqNRoNer8dgMGA0GnPfbGJZA+Yzm/lsxnkux8nJiejSmTAcDuOS/izVkbNUWZYZj0Z02m1azRaW2WdmT5hPpwwtE+ZTaq0hDzZUr0pkMxkK+Ry/LgriDVyeIz+FQp5cLsfl5SWlchlPMIw3FCQQCeINRTgIRjnwBth3h/FEkzzf2GXzm4fPez/Y3vnC5sevbG3v8mHrE78BRGELJ+HVvqkAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Invoke Channel Exit",
        "title": "Invoke Channel Exit",
        "src": "/maximo-autoscript-documentation/static/bd3fd8b2bd95daa72de68234b660ac12/655e2/invokechannel.png",
        "srcSet": ["/maximo-autoscript-documentation/static/bd3fd8b2bd95daa72de68234b660ac12/7fc1e/invokechannel.png 288w", "/maximo-autoscript-documentation/static/bd3fd8b2bd95daa72de68234b660ac12/a5df1/invokechannel.png 576w", "/maximo-autoscript-documentation/static/bd3fd8b2bd95daa72de68234b660ac12/655e2/invokechannel.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: INVOKE.ZIPCHANNEL.USEREXIT.OUT.AFTER
Language: js
New/Existing: New
Object path format: PERSON
Complete process: TRUE
Attribute values:
PERSONID TEST5
CITY BOSTON
Result:
Set STATEPROVINCE and POSTALCODE`}</p>
    <h2>{`Endpoint Scripting`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACRUlEQVQoz22R3U/aUBjG+bt3M5eYxbklugvnhTcsWdzUxSxLUD4V+RxQLAMUCm3FCUwCRWg7LB/lt7QOh4lvcnLec5Lnd57nPZ67gU6706P1u8OvZpvrmzbVmkJdaSArDWrKNUqjSavTRWm0UZU26k0budGi2enR1e7oDwy6PY3+bQvP2uYWK282WVl/z4vVd+x/8yHVFS4qNao12YVXpBoXlSpSXUaSZSpSHfWqgXf3gJdrG7ze+MCr9fesvt3Ec+wP4A+EODmN4g8EuaxUsWczLMtiUfP53F3LZc/nJJMp/IEAoXCYUDhCIBjCE4/HSCSSpNMZotEoV1fqg8C2H0EL2HLvPCgIAuL5OQVRpFAQ3bMnkUi4TS6XQ8hlyBSq5OWBI+e5WgDH47GryWazD1pBIJVK4Ukmk+Tzefcik8kgSRL9/h26PsQ0DAxDRx8OMXSdwUBnMp0+OlzAnOUwYrHYf2DOcZnNIJarXDb79Mx7tD8WtwMdzRy5fc+0mNnzx5GIouhCHTMOIx6PLwFzAmI+SyRdZD9xjT6yuJ9MMEb3GCOL0XjCaDJ1HU4mE2a2TalUdlM9AcbjiSeRVUVmOh65kZ2YuhN1+LB3u100TcM0hpimiVj4STr94190gbOzMzzLc3CGqqoqz/+GjWnoWCOTRltjPJ2jyjUK4jnlUpHLizLZbAZPIByhXC5RLBapVCpUJQlfKMJROETgJMRR5JSDYJTDoyBffSEOj09Y2Tpge9eHd+873k977Hg/s+P9wvbOR/4CBz0Lr86a+aoAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Endpoint Script",
        "title": "Endpoint Script",
        "src": "/maximo-autoscript-documentation/static/7b57cfd73e2ea320ba6ece52c3d3b71e/655e2/epscript.png",
        "srcSet": ["/maximo-autoscript-documentation/static/7b57cfd73e2ea320ba6ece52c3d3b71e/7fc1e/epscript.png 288w", "/maximo-autoscript-documentation/static/7b57cfd73e2ea320ba6ece52c3d3b71e/a5df1/epscript.png 576w", "/maximo-autoscript-documentation/static/7b57cfd73e2ea320ba6ece52c3d3b71e/655e2/epscript.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: TESTENDPOINT
Language: Python
Test Script Type: ENDPOINT
Test XML: MXITEM1.XML
Test JSON: MXITEM1.JSON
Result:
Display payload
Display script name from metadata`}</p>
    <h2>{`Condition Launch Point`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACP0lEQVQoz4WR22/SYBjG+297pSaLWbaLzQsPybxwxmRL1OxC48axHFugQGFj4zAOLQwm4hjtFKWl/Mz3GYx645s8fQ/t+3zP81W5md4yHI3pD0YMhtf0rAGtdpdWd4B9dU2zY3HRsqk3bBptm8vugFbHpmNdMRxPGH+5ZercMZncMP00RNncfcKDrV0ebj3m3sY2Rx9CWP0Bna5F17LpWX16lk3XtmXu2X05G46ueXX4jvubOzzaeSr3N7Z3UU5CYcKRGHE1gajr9QarVYDnefwvdF3n+CREJBolEo0RCkdQkqpKKpEmpxtoWY1ez2K1WrFcLuWSqEWIfrFYyIPETGTTNCmXy1RMk0rFpFgsoqhqnHQ6g6bnyWaztNtt+bGAIFnD930WnofvLyWh6AVZPp/HMAxJpmkainiIF6VSkUKhQKPRZPx5guM4uK7LbDaTcF2HmeNKQhGCsFQqyR1BJupUKoWSyWTkQEDXc/Tt3m+LQqWwKeogCCSEujWq1apUuCZMp9MowqZoDKNIycijmw2y9SlBsPrrDv+M9ahWq5H7l1DcnyQUKo0CBfOc/MWImeNwd+fiuC7TmSvti1rk7/OvzOffMCtV9FxO2haCkskkyq/GkMhqGla3I0/3xB9deDIvPY9g6RP4C3zfo311y/zHkvZlk4pZpnZ2ysV5jUIhjxKKxqjVzjg9PaVer9NstTiOJQirceIplZNkmqNYhvfhOG+PE4SiKtsvjnh+8JH9Nx/Yf33A3kuBQ57t7fMTt+AOJJnbmNoAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Condition Script",
        "title": "Condition Script",
        "src": "/maximo-autoscript-documentation/static/d2abb1ddbb2eecbe6c08cceee5376c77/655e2/condition.png",
        "srcSet": ["/maximo-autoscript-documentation/static/d2abb1ddbb2eecbe6c08cceee5376c77/7fc1e/condition.png 288w", "/maximo-autoscript-documentation/static/d2abb1ddbb2eecbe6c08cceee5376c77/a5df1/condition.png 576w", "/maximo-autoscript-documentation/static/d2abb1ddbb2eecbe6c08cceee5376c77/655e2/condition.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: SUMCOST
Language: Python
Where clause: assetnum = ‘11200’
Result:
Return True of sum of SPAREPART QTY > 10
Return False of sum of SPAREPART QTY < 10`}</p>
    <h2>{`Action Launch Point`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACOElEQVQoz4WSaW8SURSG+d1+0Jo0Lu2HtjFqYqNWY2LbuGta1mEtUoZlBATLEIal0Nayz0CBGXjMXGqNS+JN3sw5Z3Kee5br6PX6NM9a1Jtn1BsnaNVj8kcl1JLGN1WjXG2iHTfJFyqoWoNSdSG1Uqdx+p3zdpdOT+e81aZz2sBxe/0+S3fXWVrZ4NryKm8+OanU6pQrtctvVahSqy1UraNVqjRPTni+/Zobd9a4tfaAmysbLK+u49h3unC6PUj+APsuN/lCAfvM53P+d2KxGHa+x+vF4/Xhcntw+P0SfilAMBglGAxSKqmXQBhPpkwmE+Gbpsl4PObi4gLLskRcUdKkUimUdFrYiUQCRyQSEYackMWNqqoyHA6FdMNgMBhgGMaVb5rW1QU27PDwEFmWBSMajeI4ODggmUyKgP2zWCwy6PcXUMNA13Vhj0YjhsMRljW7Atp58Xhc5Np2KBT6HWhXWNYqzC9nOJvNRHv/mqcdUxRFFPETGA6HfwFlOUE6GccbzbIbqjGZmMxnM0zLEtVYlingtqamKYDZXO5vYDgc+aNlFftttttt2p02nU6XVqdHr7+IdbtdhkYfw9BJK1/4HIuJtu2C7KU6Fo4sZA9V0zSs6RRD18UypvaW5zOx9tHQEHajNWJiQblUREmnyGUz5L/miMcPcbi8PnK5LJlMhkKhwNFREacUwClJeAI+3IEg76Uw71wSb/c8vNrzcf3eDo+3P/B05yNPXuyyufWSR1vbPNx8xg8rsg1uZ8yREwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Action LP Script",
        "title": "Action LP Script",
        "src": "/maximo-autoscript-documentation/static/222d66ed84b87862924e6a396e541d3d/655e2/actionlp.png",
        "srcSet": ["/maximo-autoscript-documentation/static/222d66ed84b87862924e6a396e541d3d/7fc1e/actionlp.png 288w", "/maximo-autoscript-documentation/static/222d66ed84b87862924e6a396e541d3d/a5df1/actionlp.png 576w", "/maximo-autoscript-documentation/static/222d66ed84b87862924e6a396e541d3d/655e2/actionlp.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: CACLMETER
Language: Python
Object path: ASSET`}{`[assetnum = ‘11430’]`}{`
Result:
Set EQ7 to ASSETMETER.OLDREADING`}</p>
    <h2>{`REST api`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACVklEQVQoz32S208aQRjF9+/uS21j2qgPxQfbtD5ok6baaElFRK4uYKrc75b7Igh4AYFdEXYX3F+za/SlsZOcOSeTyck534wwGsp0r/q0u9dcdC6Rzi8oVepU6w3KtSatyxvKtRal8gVSq0u12aHW7NBotml3r7ju3TKQx/RMvuogvLetsbBkY2F5lVeLK+zsHVCpS5SqdcrVGsVylVKlZulH1ClVqkiNcza/7/B6yca7Dx95s7zK4ooNwe3x4vX5EcUQbq+XYqkEhoGqqvxvGQacnJxw6Pbg8/vx+QN4vD6EcDBEOBQiKAYRAyIN6RzDMJjN5y8YGRbPZjMy6TSpVMriTCZNIpFAcLvdOBwO7Paf7O7aKRbL1mVNVZnpOrpmQkPXdVRVY/7wYBnO53PLLBqNEo/HLTMzsSCKIgdOJ3t7Dvb3XeTzBUbyiMFIZigr9IePeiAr3I4U9Nn8OWEymSQWi1lmpg6HwwgBf4BgMMjRUdCaYzRV4Kw94PZeZTDRuB7dMZioDCca/bGZ0Hiun81mrYRPhsfHxwjmZkZPJJOkU3HESJ5fv1tMp2ZlzXocVX3UZm0zma7PrOr5fP5fQzOmeWAiEolSr9fQtQmyIqMoCrKiWNVlWabX69Hr9RkO+iiyTCaT5fQ0YtWOxxOEQiGEp6GaMIcqSdIL/+SB8Z3C9F6h1rpBHk+RahUy6RSFfI4/ZwVisSiCxx+gUMiTy+UoFouUymWc3gAunw/PkQ9XQGTHG8Tu8rJ74MN+KPJ2bZvPW042fjjY/LbNl40t1je3+bT+lb/nnQjoTKYE5QAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "REST Script",
        "title": "REST Script",
        "src": "/maximo-autoscript-documentation/static/e453884e7da927cda63f66df701e7ef8/655e2/restscript.png",
        "srcSet": ["/maximo-autoscript-documentation/static/e453884e7da927cda63f66df701e7ef8/7fc1e/restscript.png 288w", "/maximo-autoscript-documentation/static/e453884e7da927cda63f66df701e7ef8/a5df1/restscript.png 576w", "/maximo-autoscript-documentation/static/e453884e7da927cda63f66df701e7ef8/655e2/restscript.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: INVOKEREST
Language: Python
Query parameters:
personid = ‘LIBERI
siteid = ‘FLEET’
Result:
Throw exception if site is invalid
SET LOCATIONSITE to siteid`}</p>
    <h2>{`Role Scripting`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACWklEQVQoz3WRW08aQRiG9283vahNm8baC/Wih8Skse2Fpqk1qYqsCCxi5bhy8ASK7C5ykAC6C8phWXiaGb2oSbvJO9/3JTPPvPOucmN3qTXbVGsNqo0W5lWd08IFxZJB4bxE8dKieFGmUDKpNtsYVoNSqcaFWaV+3aLdueXG7tFqd7i5rqHMLrxn5u0CM3OLPHs1x89NP9ZVFcOsYFaqmNYVhlQF06pgWBZl06Reb/B19QcvZud5M/+Bl3OLvH63gLLtV1F3AoTCmqyFQpH/fZPJBNd1mXgTOSeTKbb9fgK7QSlxXvm9v48W0diL7hOLx7AsU26eAoOhy3A4lLPneYxGIykBHo/H5HI5DnWdbDYjlU6nUTRNQ/WrbG75UdUg+fwJt7aN4zj0ej263S62bcvecbqMH90JoK7rJBJJUqmUhB0cHDwAtbDGls/PxsY2pydnTL0Rw8GAfr/P3d0dg8FAOhUS7v4GJpNJCRP93t4eSigURIuE2dkNoKp+9NwptRuX6XT68PTH+q88M5nME2A0GkURixjSuk5GTxFJHOFL1RgOR9KFyKw/GMoqfoiowqnrjsnnj0gkEk+BwqYEptPE43GM8iX3PYdms0mn08F2HJxuT2baarXkPOjf0b+/J5vNEYvFpctUKk0kEkERN4hQhUSohmHI/Bzblocmnvf4yCne2JVdrX2P60G5dE42c8jxUZ7Tk2OSyQSKuhvk+PiIfD7P2dkZxeI5ajiCGg4T0ILsaBHWQ1HW1RDrvgBrvl2eL67xaWWL5dVffP72naXlFZaWV/m49IU/R/ULS14VxAAAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Role Test",
        "title": "Role Test",
        "src": "/maximo-autoscript-documentation/static/319f6e73831cdcc528a9a2cd83ce9184/655e2/roletest.png",
        "srcSet": ["/maximo-autoscript-documentation/static/319f6e73831cdcc528a9a2cd83ce9184/7fc1e/roletest.png 288w", "/maximo-autoscript-documentation/static/319f6e73831cdcc528a9a2cd83ce9184/a5df1/roletest.png 576w", "/maximo-autoscript-documentation/static/319f6e73831cdcc528a9a2cd83ce9184/655e2/roletest.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: MAXROLE.EMXROLE
Language: Python
Where clause: assetnum = ‘11430’
Result:
Check for PERSONGROUP TIER1 and TIER2`}</p>
    <h2>{`MXException script`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACUklEQVQoz2WQ2U8TURTG+28bH8RoDOID8OCSkBjUB4ghaAxKS6cbLd0XaGuZbrTTdqDQbTpTWma6/MxcFEG/5OTecybnd79vHH1NR73s0lIvUNsd6o1zCnKZYvkMuVShVK0jV+qirzXbnF/1KFdVytUWzXaXTndAXzPodHv02yqO5bXXLL1cY2llnUfPVtjdc9JoqdSVJvVGi5p9Kk1qSoO60uCsrlBTFM4vLvi4vcOT5VVerL7h6co6z1+t4dh3unC63Hi9fpyuA2S5iC3z5gbLsvij2WzGfS2AcDiCve+WJNySB9eBG4fP58XnC+D3R/BIPirlCvP5HNM0BeR+2XO7bNmPHWcypNNpcR4fZ0gmkzhCoZC4JBIJotEYsiwzGAwYGQbDoY6maej6EF3XGWhDrOmt0+l0JmCxWEzs2oxwOIzj6OiIVColBvFYjIJcpD3U6YwmdIwxak/jyhiLvq2PsWbz38Cp2IvH42LXvh8eHv4FJhJJ0qk43kiO3XCTiWkxm8+5MU1MyxLOzOmM+WIhgHb0TCbzABgMBv9xGI+RLxRRLzUR0TB0dN1AGxqMRiMMMTPEt+vxmGw2JyI/AAaDoTtgNBpFUeqMr0f0ej36/b4o2+FkMqHT6WAYIxbzKdOpxclJlkgkIlzaCQOBAI7bJiHK/qnVapX/JGIu7lq1e401g2qlxHEmTT6XpfAzLxI6XJKHfD5HNpvl9PSUYqnEvsfPviRx4JVw+QJ89Qb54vKyu+di54fE4/Ud3m19Z3P7G+8/fWZjc4uNzW3ebnzgF1z4DCe+i53VAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "MXException Test",
        "title": "MXException Test",
        "src": "/maximo-autoscript-documentation/static/44be6335066b3f3d2352c0b6e5049449/655e2/mxetest.png",
        "srcSet": ["/maximo-autoscript-documentation/static/44be6335066b3f3d2352c0b6e5049449/7fc1e/mxetest.png 288w", "/maximo-autoscript-documentation/static/44be6335066b3f3d2352c0b6e5049449/a5df1/mxetest.png 576w", "/maximo-autoscript-documentation/static/44be6335066b3f3d2352c0b6e5049449/655e2/mxetest.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Result: Display original and additional message`}</p>
    <h2>{`Formula script`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "624px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACTklEQVQoz2WR7U/aUBTG+zfv65Ysy9yWvZi5xGXJ/OC2xM24JZo4WygoUIzKi0gQBqW1AqIgCkJBXgu/pVdwMTvJk5x7mvO7z3MrNW5sLi7rnF1cUq5cYZ2W0Q0L3TihUKqQ08vkzAKmVcAqlrGK5+StEqZVpHhepVKr02jaXF3XaVTPkV69/8izNx94+nqBxy/esbbxG8O0yOZNcnkD3Twhqxvk8qa4JG+eoBsmp4USyz9+8eTlPHPzi4Ix93YByeNV8ao+dgJBFK9KLqczK2c8YTQa3Z+HwyH9fv9+FolEUDxefP5tIZcjhUMaYU0jGAgIGYYhFgeDPt1un07nVkAGgwG9ngtzBMyFJpNJEolDkkdHJJNHxONxJFmWkbdk1tc3UBSFTCZDvV7Htm3abZtWqzXt27Ts9gPg4eGhcBmLxQRsb28PSVVVPIoHWVbQwhqlYlEsjMdjseTK7e9rMnkAjEajAub2mqYhqT6VYDAoDgd7uwQOjtmKVxk54/t9FzGZ9ZOJkFupVEo4nAHD4TDS7u4uiURCDGKxKKl0FuusJmK6ce8it7hptmh3ulP3d8B0Ov0/MKRpYuAqGomQ1fNc2W1q9i2XrQ7l6wbVZptKs02r25/G/+dwf39fxI7F4oRCIaTZo7pyP+r5PEPHYeiMhW57PYajEY4zYmqMWrNP9WaIrufE300fp/iTSRONRpC8/m3S6WNxWzabRdd1ZP8Oit+Huq2i7ARY9wf5qQbZ3JQJaBrPF1d5NL/G0soG31Z+8Hn5O0tfVvm09JW/QjYJ1+KY0wgAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Formula Test",
        "title": "Formula Test",
        "src": "/maximo-autoscript-documentation/static/6a2cd243cb485c78f646271368a40c79/655e2/formulatest.png",
        "srcSet": ["/maximo-autoscript-documentation/static/6a2cd243cb485c78f646271368a40c79/7fc1e/formulatest.png 288w", "/maximo-autoscript-documentation/static/6a2cd243cb485c78f646271368a40c79/a5df1/formulatest.png 576w", "/maximo-autoscript-documentation/static/6a2cd243cb485c78f646271368a40c79/655e2/formulatest.png 624w"],
        "sizes": "(max-width: 624px) 100vw, 624px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Name: STANDARDDEV
Language: Python
New/Existing: Existing
Object path format: ASSET`}{`[assetnum=’11430’]`}{`
Properties:
param`}{`[0]`}{` = “ALLWO”
param`}{`[1]`}{` = “estlabcost”
Result:
Display standard deviation`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      